module.exports = __webpack_public_path__ + "static/media/esign_kyc_fail.c9eecc57.svg";